import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreateLocationDto } from './create-location.dto';

/**
 * Update location DTO
 */
export class UpdateLocationDto extends CreateLocationDto {
	@TransformInt()
	id!: number;
}
